"use strict";

var lang = navigator.language || navigator.userLanguage;
var baseUrl = window.location.origin + "/projetsPersonnel/Moelleux_au_Chocolat/";

if (!window.location.pathname.includes("/fr") &&
    !window.location.pathname.includes("/en") &&
    !window.location.pathname.includes("/nl")) {

  if (lang.startsWith("fr")) {
    window.location.href = baseUrl + "fr/index.html";
  } else if (lang.startsWith("nl")) {
    window.location.href = baseUrl + "nl/index.html";
  } else {
    window.location.href = baseUrl + "en/index.html";
  }
}



